import React, { useEffect, useRef } from 'react'
import { gsap, Power1 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import styles from 'components/mvv/Mvv/Brand.module.scss'

gsap.registerPlugin(ScrollTrigger)

const OurValue: React.FC = () => {
  const sectionRef = useRef<HTMLElement | null>(null)

  useEffect(() => {
    if (sectionRef.current) {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.current,
          start: 'top 80%',
          toggleActions: 'play none none reverse',
        },
      })

      tl.from(
        sectionRef.current.querySelectorAll(
          `.${styles.value_top_num}, .${styles.value_top_ttl}, .${styles.value_desc}`,
        ),
        {
          y: 50,
          duration: 0.5,
          opacity: 0,
          ease: Power1.easeOut,
          stagger: 0.2,
        },
      )
    }

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill())
    }
  }, [])

  return (
    <section className={styles.section} ref={sectionRef}>
      <div className={styles.inner}>
        <div className={styles.section_top}>
          <span className={styles.section_top_icon}></span>
          <h2 className={styles.section_top_ttl}>
            <span className={styles.section_top_ttl_en}>Our value</span>
            <span className={styles.section_top_ttl_ja}>行動規範</span>
          </h2>
        </div>
        <div className={styles.value}>
          <h3 className={styles.value_top}>
            <span className={styles.value_top_num}>01</span>
            <span className={styles.value_top_ttl}>
              Be modern, Be standard
              <span className={styles.value_top_ttl_ja}>― 先端を捉え、新たな標準を創る</span>
            </span>
          </h3>
          <div className={styles.value_desc}>
            私たちは、常に最新の手法を取り入れ、新しいスタンダードを設定することで、変化の激しい現代社会をリードします。このアプローチにより、技術の進歩に迅速に対応し、継続的に自身をアップデートすることが可能になります。
          </div>
        </div>
        <div className={styles.value}>
          <h3 className={styles.value_top}>
            <span className={styles.value_top_num}>02</span>
            <span className={styles.value_top_ttl}>
              One for all, All for one
              <span className={styles.value_top_ttl_ja}>― チームで最大の成果を出す</span>
            </span>
          </h3>
          <div className={styles.value_desc}>
            私たちは、異なる専門分野や視点の融合が革新を生み出すと考えています。この過程では、多様な背景を持つメンバーがお互いを理解し合い、協力することが鍵となります。ビジョンの達成には個人の努力だけでは不十分であり、チームの力が不可欠です。それぞれの才能と能力が相乗効果を生み出し、共通の目標に向かって前進することが重要です。
          </div>
        </div>
        <div className={styles.value}>
          <h3 className={styles.value_top}>
            <span className={styles.value_top_num}>03</span>
            <span className={styles.value_top_ttl}>
              User Focus
              <span className={styles.value_top_ttl_ja}>― ユーザーにフォーカスして顧客に絶対的価値を届ける</span>
            </span>
          </h3>
          <div className={styles.value_desc}>
            私たちは、日常を豊かにするサービスを生み出すことにフォーカスします。世の中にとって本当に意味のあるものを作れているか？常に物事の本質から考え、利用者のニーズに密接に寄り添いながら、誠実にものづくりに取り組みます。
          </div>
        </div>
        <div className={styles.value}>
          <h3 className={styles.value_top}>
            <span className={styles.value_top_num}>04</span>
            <span className={styles.value_top_ttl}>
              Professional Work
              <span className={styles.value_top_ttl_ja}>― 技を磨き、市場に示す</span>
            </span>
          </h3>
          <div className={styles.value_desc}>
            私たちは、プロフェッショナルとしての姿勢を持ち、顧客のニーズを最優先に考え、質の高い価値提供に尽力します。依頼内容を超えて顧客に真の価値をもたらすことを目指し、日々自己研鑽を重ね、常に最良の行動を選択することに注力します。このような姿勢により、顧客との信頼関係を深め、ビジネスに実質的な貢献を目指します。
          </div>
        </div>
      </div>
    </section>
  )
}

export default OurValue
